import {BaseService} from "../../../common/lib/service/base";
import {AMBULANCE_TYPE} from "../config";

class Staff extends BaseService {
    constructor() {
        super()
    }

    /**
     * 登录
     * @param userMobile
     * @param userPassword
     * @param userType
     * @returns {Promise<void>}
     */
    async login({userMobile, userPassword, userType}) {
        const {obj, token, code} = await this.$http('smarthos.staff.user.login', {userMobile, userPassword, userType});
        return code === '0' ? {token, obj} : {}
    }

    /**
     *
     * @param userType
     * @param pageNo
     * @param pageSize
     * @returns {Promise<{page: *, list: *}>}
     */
    async listsDoc({userType, pageNo = 1, pageSize = 10}) {
        let {code, list = [], page = {}} = await this.$http('smarthos.emergency.staffing.config.page', {
            userType,
            pageNo,
            pageSize
        });
        list = list.map(r => {
            r.enabled_class = r.enabled ? 'color_main' : 'color_red';
            r.enabled_text = r.enabled ? '启用' : '停用';
            r.opera_btn = !r.enabled ? '启用' : '停用';
            return r;
        });
        return {list, page};
    }

    /**
     *
     * @returns {Promise<[]>}
     */
    async listDocNoPage(userType) {
        const {list = []} = await this.$http('smarthos.emergency.staffing.config.list', {userType});
        return list;
    }

    /**
     *
     * @param id
     * @returns {Promise<void>}
     */
    async detailDoc(id) {
        const {obj = {}} = await this.$http('smarthos.emergency.staffing.config.details', {id});
        return obj;
    }

    /**
     *
     * @param userId
     * @returns {Promise<boolean>}
     */
    async addDoc(userId) {
        const {code} = await this.$http('smarthos.emergency.staffing.config.create', {
            userId
        });
        return code === '0';
    }

    /**
     *
     * @param id
     * @param userId
     * @returns {Promise<boolean>}
     */
    async modifyDoc(id, userId) {
        const {code} = await this.$http('smarthos.emergency.staffing.config.modify', {
            id, userId
        });
        return code === '0'
    }

    /**
     *
     * @param id
     * @param enabled
     * @returns {Promise<boolean>}
     */
    async enabledDoc(id, enabled) {
        const {code} = await this.$http('smarthos.emergency.staffing.config.enabled', {
            id, enabled
        });
        return code === '0'
    }

    /**
     *
     * @param id
     * @param enabled
     * @returns {Promise<boolean>}
     */
    async enabledDoc(id, enabled) {
        const {code} = await this.$http('smarthos.emergency.staffing.config.enabled', {
            id, enabled
        });
        return code === '0'
    }

    /**
     * 司机
     * @param pageNo
     * @param pageSize
     * @returns {Promise<{page: *, list: *}>}
     */
    async listDriver({pageNo = 1, pageSize = 10}) {
        let {list, page} = await this.$http('smarthos.staff.user.driver.page', {
            pageNo,
            pageSize
        });
        list = list.map(r => {
            const {staffStatus} = r;
            r.status_text = staffStatus === "START_USING" ? '启用' : "停用";
            r.status_class = staffStatus === "START_USING" ? 'color_main' : 'color_red';
            r.opera_btn = staffStatus === "START_USING" ? '停用' : '启用';
            return r;
        })
        return {list, page}
    }

    /**
     *
     * @returns {Promise<[]>}
     */
    async listDriverNoPage() {
        const {list = []} = await this.$http('smarthos.staff.user.driver.list', {});
        return list;
    }

    /**
     *
     * @param form
     * @returns {Promise<boolean>}
     */
    async addDriver(form) {
        const {code} = await this.$http('smarthos.staff.user.driver.create', form);
        return code === '0';
    }

    /**
     *
     * @param form
     * @returns {Promise<boolean>}
     */
    async modifyDriver(form) {
        const {code} = await this.$http('smarthos.staff.user.driver.modify', form);
        return code === '0';
    }

    /**
     *
     * @param staffStatus
     * @param id
     * @returns {Promise<boolean>}
     */
    async startOrStopDriver(staffStatus, id) {
        const {code} = await this.$http('smarthos.staff.user.driver.status', {staffStatus, id});
        return code === '0';
    }


    /**
     * 救护车
     * @param pageNo
     * @param pageSize
     * @returns {Promise<{page: *, list: *}>}
     */
    async listCar({pageNo = 1, pageSize = 10}) {
        let {code, list, page} = await this.$http('smarthos.emergency.ambulance.page', {
            pageNo,
            pageSize
        });
        list = list.map(r => {
            r.ambulanceTypeText = (AMBULANCE_TYPE[r.ambulanceType] && AMBULANCE_TYPE[r.ambulanceType].name) || r.ambulanceType;
            r.enabled_class = r.enabled ? 'color_main' : 'color_red';
            r.enabled_text = r.enabled ? '启用' : '停用';
            r.opera_btn = !r.enabled ? '启用' : '停用';
            return r;
        });
        return {list, page}
    }

    /**
     *
     * @returns {Promise<[]>}
     */
    async listCarNoPage() {
        const {list = []} = await this.$http('smarthos.emergency.ambulance.list', {});
        return list
    }

    /**
     *
     * @param form
     * @returns {Promise<boolean>}
     */
    async addCar(form) {
        const {code} = await this.$http('smarthos.emergency.ambulance.create', form);
        return code === '0';
    }

    /**
     *
     * @param form
     * @returns {Promise<boolean>}
     */
    async modifyCar(form) {
        const {code} = await this.$http('smarthos.emergency.ambulance.modify', form);
        return code === '0';
    }

    /**
     *
     * @param enabled
     * @param id
     * @returns {Promise<boolean>}
     */
    async startOrStopCar(enabled, id) {
        const {code} = await this.$http('smarthos.emergency.ambulance.enabled', {enabled, id});
        return code === '0';
    }

    /**
     *
     * @param aspectUser
     * @param statusList
     * @param patName
     * @param startTime
     * @param endTime
     * @param referralStartTime
     * @param referralEndTime
     * @param pageNo
     * @param pageSize
     * @param hasEmergencyReferral
     * @returns {Promise<{page: *, list: *}>}
     */
    async listOrder({
                        aspectUser,
                        statusList,
                        patName,
                        startTime,
                        endTime,
                        referralStartTime,
                        referralEndTime,
                        pageNo = 1,
                        pageSize = 10,
                        hasEmergencyReferral = true
                    }) {
        const {list = [], page = {}} = await this.$http('smarthos.emergency.referral.order.list', {
            aspectUser,
            statusList,
            patName,
            startTime,
            endTime,
            referralStartTime,
            referralEndTime,
            pageNo,
            pageSize,
            hasEmergencyReferral
        }).catch(error => {
            Log('smarthos.emergency.referral.order.list', error);
            return {list: [], page: []};
        });
        return {list, page}
    }

    /**
     *
     * @param orderId
     * @returns {Promise<void>}
     */
    async detailOrder(orderId) {
        const {obj = {}} = await this.$http('smarthos.emergency.referral.order.detail', {orderId}, 'post', false);
        return obj;
    }


    /**
     *
     * @param orderId
     * @returns {Promise<boolean>}
     */
    async cancelOrder(orderId) {
        const {code} = await this.$http('smarthos.emergency.referral.order.cancel', {orderId});
        return code === '0';
    }

    /**
     *
     * @param orderId
     * @param referralTime
     * @param dispatchingCarType
     * @param emergencyAmbulanceId
     * @param staffingList
     * @param remark
     * @param transportCarefulMatter
     * @param directorDoc
     * @param directorDocMobile
     * @returns {Promise<boolean>}
     */
    async processOrder({
                           orderId,
                           referralTime,
                           dispatchingCarType,
                           emergencyAmbulanceId,
                           staffingList,
                           remark,
                           transportCarefulMatter,
                           directorDoc,
                           directorDocMobile
                       }) {
        const {code} = await this.$http('smarthos.emergency.referral.order.process', {
            orderId,
            referralTime,
            dispatchingCarType,
            emergencyAmbulanceId,
            staffingList,
            remark,
            transportCarefulMatter,
            directorDoc,
            directorDocMobile
        });
        return code === '0'
    }

    /**
     *
     * @param orderId
     * @param referralTime
     * @param dispatchingCarType
     * @param emergencyAmbulanceId
     * @param staffingList
     * @param remark
     * @param transportCarefulMatter
     * @param directorDoc
     * @param directorDocMobile
     * @returns {Promise<boolean>}
     */
    async perfectOrder({
                           orderId,
                           referralTime,
                           dispatchingCarType,
                           emergencyAmbulanceId,
                           staffingList,
                           remark,
                           transportCarefulMatter,
                           directorDoc,
                           directorDocMobile
                       }) {
        const {code} = await this.$http('smarthos.emergency.referral.order.perfect', {
            orderId, referralTime, dispatchingCarType, emergencyAmbulanceId, staffingList, remark,
            transportCarefulMatter,
            directorDoc,
            directorDocMobile
        });
        return code === '0'
    }

    /**
     * 改变流程
     * @param procedureStatus
     * @param orderId
     * @returns {Promise<boolean>}
     */
    async changeOrderState({procedureStatus, orderId}) {
        const {code} = await this.$http('smarthos.emergency.referral.order.procedure', {orderId, procedureStatus});
        return code === '0';
    }

    /**
     *
     * @param form
     * @returns {Promise<boolean>}
     */
    async addOrder(form) {
        const {code} = await this.$http('smarthos.emergency.referral.order.issue', form);
        return code === '0';
    }

    /**
     * 远程会诊发起
     * @returns {Promise<string>}
     */
    async addConsultOrder(form) {
        const {code = ''} = await this.$http('smarthos.emergency.referral.order.consult.issue', form);
        return code
    }

    /**
     *
     * @param form
     * @returns {Promise<boolean>}
     */
    async modifyOrder(form) {
        const {code} = await this.$http('smarthos.emergency.referral.order.modify', form);
        return code === '0';
    }

    /**
     *
     * @param orderId
     * @param intovideoPushType
     * @returns {Promise<*|{}>}
     */
    async intoVideo(orderId, intovideoPushType) {
        const {obj = {}} = await this.$http('smarthos.emergency.referral.order.intovideo.v2', {
            orderId,
            intovideoPushType
        }, 'post', false);
        return obj.videoHushiEnterRoom || {}
    }

    /**
     * 转入转出详情
     * @param emergencyReferralOrderId
     * @param applicationType
     * @returns {Promise<void>}
     */
    async detailApply(emergencyReferralOrderId, applicationType) {
        const {obj = {}} = await this.$http('smarthos.emergency.transhipment.application.form.details', {
            emergencyReferralOrderId, applicationType
        });
        return obj;
    }

    /**
     *
     * @param form
     * @returns {Promise<boolean>}
     */
    async subApply(form) {
        const {code} = await this.$http('smarthos.emergency.transhipment.application.form.save', form);
        return code === '0';
    }

    /**
     *
     * @param emergencyReferralOrderId
     * @returns {Promise<[]>}
     */
    async listRecord(emergencyReferralOrderId) {
        const {list = [], page = {}} = await this.$http('smarthos.emergency.treatment.process.records.pagelist', {
            emergencyReferralOrderId
        });
        return {list, page};
    }

    /**
     *
     * @param emergencyReferralOrderId
     * @param treatmentProcess
     * @param loggingTime
     * @param attaIdList
     * @returns {Promise<boolean>}
     */
    async addRecord({
                        emergencyReferralOrderId,
                        treatmentProcess,
                        loggingTime,
                        attaIdList,
                        heartRate,
                        bloodPressure,
                        oxygenSaturation,
                        respiratoryRate,
                        bloodPressureUpper,
                        bloodPressureLower
                    }) {
        const {code} = await this.$http('smarthos.emergency.treatment.process.records.insert', {
            emergencyReferralOrderId,
            treatmentProcess,
            loggingTime,
            attaIdList,
            heartRate,
            bloodPressure,
            oxygenSaturation,
            respiratoryRate, bloodPressureUpper, bloodPressureLower
        });
        return code === '0';
    }

    /**
     *
     * @param treatmentProcess
     * @param loggingTime
     * @param attaIdList
     * @param id
     * @returns {Promise<boolean>}
     */
    async modifyRecord({
                           treatmentProcess,
                           loggingTime,
                           attaIdList,
                           id,
                           heartRate,
                           bloodPressure,
                           oxygenSaturation,
                           respiratoryRate,
                           bloodPressureUpper,
                           bloodPressureLower
                       }) {
        const {code} = await this.$http('smarthos.emergency.treatment.process.records.modify', {
                treatmentProcess,
                loggingTime,
                attaIdList,
                id,
                heartRate,
                bloodPressure,
                oxygenSaturation,
                respiratoryRate,
                bloodPressureUpper,
                bloodPressureLower
            })
        ;
        return code === '0'
    }

    async deleteRecord(id) {
        const {code} = await this.$http('smarthos.emergency.treatment.process.records.disabled', {
            id
        });
        return code === '0';
    }

    /**
     *
     * @param id
     * @returns {Promise<void>}
     */
    async trace(id, pageNum = 1, list = []) {
        let {obj = {}, code} = await this.$http('smarthos.gaode.trace.terminal.search', {id, pageNum});
        if (obj.points) list = list.concat(obj.points);
        if (obj.counts !== list.length && code === '0') return (await this.trace(id, ++pageNum, list));
        return list;
    }

    /**
     *
     * @param id
     * @returns {Promise<void>}
     */
    async detailComment(id) {
        const {obj = {}} = await this.$http('smarthos.emergency.comment.details', {
            orderId: id
        });
        return obj;
    }

    async count() {
        const {obj = {}} = await this.$http('smarthos.emergency.demo.count', {});
        return obj;
    }

    async today() {
        const {obj = {}} = await this.$http('smarthos.emergency.demo.today.count', {});
        return obj;
    }

    /**
     *
     * @param orderId
     * @returns {Promise<void>}
     */
    async detail(orderId) {
        const {obj = {}} = await this.$http('smarthos.emergency.demo.order.detail', {
            orderId
        });
        return obj;
    }

    /**
     * 评价
     * @param orderId
     * @returns {Promise<void>}
     */
    async listPj(orderId) {
        const {list = []} = await this.$http('smarthos.emergency.comment.list', {
            orderId
        });
        return list;
    }

    /**
     * 患者评估-新增/修改
     * @param form
     * @returns {Promise<void>}
     */
    async pg(form) {
        const {code} = await this.$http('smarthos.emergency.transhipment.patient.assessment.save', form);
        return code === '0'
    }

    /**
     * 评估详情
     * @param emergencyReferralOrderId
     * @returns {Promise<void>}
     */
    async pgDetail(emergencyReferralOrderId) {
        const {obj = {}} = await this.$http('smarthos.emergency.transhipment.patient.assessment.details', {emergencyReferralOrderId})
        return obj;
    }

    /**
     * 选择临床业务科室
     * @returns {Promise<*[]>}
     */
    async listDept() {
        const {list = []} = await this.$http('smarthos.emergency.dept.list', {});
        return list;
    }

    /**
     * 审核
     * @param options
     * @param options.orderId
     * @param options.auditStatus
     * @param options.transferBusinessDeptId
     * @param options.disagreeReason
     * @returns {Promise<string>}
     */
    async orderExamine(options) {
        const {code} = await this.$http('smarthos.emergency.referral.order.examine', options);
        return code;
    }
}

export const staffService = new Staff();
